$(function() {
    $(".hamburger").click(function() {
        $(this).toggleClass("is-active");
        $(".mainnav-center").toggleClass("show");
        $("body").toggleClass("nav-open");
    });
});

$(".toggle-mobile-dropdown").click(function() {
    $(this).parent().next(".nav-dropdown-big").slideToggle();
    $(this).toggleClass('toggled');
});
